export const UNKNOWN_HTTP_FAILURE_RESPONSE_REGEX = /^Http failure response for .+: 0 Unknown Error$/;
export const SENTRY_RECURRING_REQUESTS_IGNORE_STATUS_CODES = new Set([403, 502, 503, 0]);
